export enum FileEventsEnum {
	FileProcessingStarted = 'file-processing.started',
	FileProcessingFinished = 'file-processing.finished',
	FileProcessingCrashed = 'file-processing.crashed',
}
